var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTutorialBottomArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 55,
    viewBox: "0 0 11 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.194572 45.0766C0.865386 48.4306 2.59034 51.3055 4.69861 53.8931C5.17792 54.4681 6.13622 54.2763 6.51954 53.7013C8.24449 50.6347 9.68195 47.2807 10.0653 43.7351C10.1611 42.681 8.53198 42.585 8.34032 43.5433C7.66951 46.1307 6.7112 48.6224 5.46541 51.018C4.98625 50.3472 4.50694 49.5806 4.12362 48.8139C4.79444 49.4848 6.32788 49.1973 6.32788 47.9515C6.42371 32.3311 9.96944 16.2317 7.19035 0.802857C6.99869 -0.442939 4.89042 -0.155445 4.98625 1.09035C6.23205 16.8066 3.83613 32.2351 3.7403 47.9515C3.7403 48.0473 3.7403 48.1431 3.7403 48.1431C3.16532 46.9932 2.78215 45.8432 2.4945 44.5016C2.30269 42.9683 -0.0929203 43.5433 0.194572 45.0766Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTutorialBottomArrowWhite);
export default __webpack_public_path__ + "static/media/ic_tutorial_bottom_arrow_white.8530c106ed9160cce38da540628dfaf1.svg";
export { ForwardRef as ReactComponent };